import { Avatar, OutlinedInput } from "@mui/material";
import React, { useState } from "react";
import Rupee from "../assets/Rupee.svg";
import CommonDatePicker from "../../views/CommonDatePicker";
import dayjs from "dayjs";
import TrendlineUp from "../assets/TrendlineUp.svg";
import TrendlineDown from "../assets/TrendlineDown.svg";
import Dropdown_icon from "../assets/Dropdown_icon.svg";
import { postRequest } from "../axiosClient";
import { ADD_EMPLOYEE_SALARY_RECORD } from "../utils";
import {
  errorNotification,
  successNotification,
} from "../toast-notification/common-toast";
import { useNavigate } from "react-router-dom";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import { NumericFormat } from "react-number-format";
const AddRevised = ({
  show,
  setShow,
  employeeData,
  revisions,
  formatSalary,
  formatDate,
  GetEmployeeSalary,
}) => {
  const [salary, setSalary] = useState("");
  const [note, setNote] = useState("");
  const [isNote, setIsNote] = useState(false);
  const [effectiveDate, setEffectiveDate] = useState(null);
  const navigate = useNavigate();

  const handleCloseRevised = () => {
    setShow(false);
    setSalary("");
    setEffectiveDate(null);
    setNote("");
  };

  const handleSave = async () => {
    const requestData = {
      user_id: employeeData?.id,
      salary: salary,
      effective_date: effectiveDate,
      note: isNote ? note : null,
    };

    try {
      const response = await postRequest(
        ADD_EMPLOYEE_SALARY_RECORD,
        requestData
      );
      if (response.type === 1) {
        successNotification("Salary revised successfully!");
        GetEmployeeSalary();
        handleCloseRevised();
      } else {
        const error = response?.errormessage;
        errorNotification(error);
      }
    } catch (error) {
      errorNotification(error);
    }
  };

  return show ? (
    <div className="w-full flex flex-col md:flex-row justify-start items-start">
      <div className="w-full p-2">
        <div className="bg-white  border border-gray-200 shadow-md rounded-lg w-full p-6">
          <div className="flex justify-between items-center border-b pb-4">
            <h1 className="text-xl font-semibold">Revise Salary</h1>
            <div className="flex justify-start items-center gap-3">
              <button
                className={`px-4 py-2 text-white rounded-md cursor-pointer ${salary === "" || effectiveDate === null
                  ? "bg-gray-400"
                  : "bg-[#267072]"
                  } `}
                onClick={() => {
                  handleSave();
                }}
                disabled={salary === "" || effectiveDate === null}
              >
                Revise
              </button>
              <button
                className="mr-2 px-4 py-2 text-gray-600 bg-gray-200 rounded-md hover:bg-gray-300"
                onClick={handleCloseRevised}
              >
                Cancel
              </button>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row justify-between items-start">
            <div className="lg:w-3/5 w-full p-2">
              <div className="mt-4 grid grid-cols-1 gap-4 text-gray-700 sm:grid-cols-2">
                <div className="col-span-1 flex items-center">
                  <div>
                    {
                      <Avatar
                        src={employeeData?.profile_image}
                        alt="Profile Image"
                        className="w-12 h-12 rounded-full"
                      />
                    }
                  </div>
                  <div className="ml-3">
                    <h2 className="font-medium">
                      {employeeData?.first_name + " " + employeeData?.last_name}
                    </h2>
                    <p className="text-sm text-gray-500">
                      {employeeData?.role?.name || "--"}
                    </p>
                  </div>
                </div>

                <div className="col-span-1">
                  <p className="text-sm text-gray-500 uppercase">
                    Date of Joining
                  </p>
                  <p>
                    {dayjs(employeeData?.joining_date).format("MMMM DD, YYYY")}
                  </p>
                </div>

                <div className="col-span-1">
                  <p className="text-sm text-gray-500 uppercase">Department</p>
                  <p>{employeeData?.department?.department_name}</p>
                </div>

                <div className="col-span-1">
                  <p className="text-sm text-gray-500 uppercase">
                    Current Salary
                  </p>
                  <p>
                    {revisions.map((currentSalary, idx) => (
                      <React.Fragment key={idx}>
                        {currentSalary.is_current === true && (
                          <>INR {formatSalary(currentSalary.salary)}</>
                        )}
                      </React.Fragment>
                    ))}
                  </p>
                </div>
              </div>
              <div className="mt-6">
                <h2 className="text-lg font-semibold text-gray-800">
                  New salary details
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4 mb-3">
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">
                      New Salary
                    </label>
                    <NumericFormat
                      value={salary}
                      thousandsGroupStyle="lakh"
                      thousandSeparator=","
                      onValueChange={(values) => {
                        setSalary(values.value);
                      }}
                      customInput={OutlinedInput}
                      className="h-[40px] w-fit rounded-lg shadow-sm"
                      inputProps={{
                        "aria-label": "salary",
                      }}
                      sx={{
                        borderRadius: "8px",
                      }}
                      endAdornment={
                        <img src={Rupee} className="h-5 w-5" alt="Rupee" />
                      }
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">
                      Effective from
                    </label>
                    <CommonDatePicker
                      value={effectiveDate}
                      onChange={(newValue, formattedDate) =>
                        setEffectiveDate(formattedDate)
                      }
                      min={new Date(revisions?.[0]?.effective_date)}
                      // min={new Date(dayjs(revisions?.[0]?.effective_date).add(1, "day").format("YYYY-MM-DD"))}
                      label="Salary Effective Date"
                      className="common-date-picker w-full max-w-[250px] min-w-fit"
                      placeholder="Enter Salary Effective Date"
                    />
                  </div>
                </div>

                {!isNote ? (
                  <button
                    className="mt-4 text-purple-600 text-sm hover:underline"
                    onClick={(e) => setIsNote(true)}
                  >
                    +Add Note
                  </button>
                ) : (
                  <div className="col-12">
                    <h6 className="modal-heading">Add Note</h6>
                    <input
                      type="text"
                      placeholder="Enter note"
                      className={`border w-full max-w-full border-[#cfcbcb] rounded-md px-2 py-1 bg-transparent`}
                      // style={{
                      //     fieldSizing: "content",
                      // }}
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="lg:w-2/5 w-full p-2 pt-4 ">
              <div className="max-w-3xl relative">
                {revisions.map((revision, index) => (
                  <div key={index} className="relative">
                    <div className="absolute left-4 top-0 flex flex-col items-center">
                      <div
                        className={`w-6 h-6 rounded-full flex items-center justify-center text-white ${revision.is_current ? "bg-teal-500" : "bg-[#267072]"
                          }`}
                      >
                        {revisions?.[index + 1] &&
                          revision.salary == revisions?.[index + 1]?.salary ? (
                          <TrendingFlatIcon
                            alt="Arrow Icon flat"
                            className="w-4 h-4 text-white bg-inherit rounded-full"
                          />
                        ) : revision?.salary <
                          revisions?.[index + 1]?.salary ? (
                          <img
                            src={TrendlineDown}
                            alt="Arrow Icon down"
                            className="w-4 h-4"
                          />
                        ) : (
                          <img
                            src={TrendlineUp}
                            alt="Arrow Icon up"
                            className="w-4 h-4"
                          />
                        )}
                      </div>
                    </div>

                    {index < revisions.length - 1 && (
                      <div className="w-0.5 h-full bg-gray-300 absolute left-[27px] top-6 flex flex-col items-center"></div>
                    )}

                    <div className="ml-10 pb-2 lg:w-[calc(100%-70px)]">
                      <div className="flex items-center justify-start gap-4 p-3 pt-0 w-full">
                        <h3 className="font-semibold text-sm">
                          INR {formatSalary(revision.salary)},{" "}
                          <span className="text-sm text-gray-500">
                            Effective {formatDate(revision.effective_date)}
                          </span>
                        </h3>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default AddRevised;
